/**
 * Client helpers for shoe_studio_prefs (Phase 0 Master Hub).
 */

import { STRONOM_HIST1_STYLE_KEY } from "@/features/footwear-studio/featureFlags";
import { apiFetch } from "@/lib/apiFetch";

export const DEFAULT_STUDIO_ORG_KEY = "brand.com";

export type ShoeStudioPrefs = {
  org_key: string;
  upload_path: string;
  style_id?: string | null;
  active_master_job_id: string | null;
  pinned_job_ids: string[];
  updated_at?: string;
};

export type ShoeStudioPrefsOptions = {
  styleId?: string | null;
};

export async function fetchShoeStudioPrefs(
  uploadPath: string | null | undefined,
  orgKey: string = DEFAULT_STUDIO_ORG_KEY,
  options?: ShoeStudioPrefsOptions
): Promise<ShoeStudioPrefs | null> {
  try {
    const params = new URLSearchParams({
      org_key: orgKey,
    });
    if (uploadPath) {
      params.set("upload_path", uploadPath);
    }
    // HUB-1 / HIST-1c: style_id-only GET is valid (API prefers style_id when present).
    if (options?.styleId) {
      params.set("style_id", options.styleId);
    }
    if (!uploadPath && !options?.styleId) {
      return null;
    }
    const res = await apiFetch(`/api/shoe-studio-prefs?${params.toString()}`);
    const data = await res.json();
    if (!data?.ok) return null;
    return data.prefs as ShoeStudioPrefs;
  } catch {
    return null;
  }
}

export async function upsertShoeStudioPrefs(
  uploadPath: string,
  patch: {
    active_master_job_id?: string | null;
    pinned_job_ids?: string[];
    style_id?: string | null;
  },
  orgKey: string = DEFAULT_STUDIO_ORG_KEY,
  options?: ShoeStudioPrefsOptions
): Promise<ShoeStudioPrefs | null> {
  try {
    const body: Record<string, unknown> = {
      org_key: orgKey,
      upload_path: uploadPath,
      ...patch,
    };
    if (STRONOM_HIST1_STYLE_KEY && options?.styleId) {
      body.style_id = options.styleId;
    }
    const res = await apiFetch("/api/shoe-studio-prefs", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!data?.ok) return null;
    return data.prefs as ShoeStudioPrefs;
  } catch {
    return null;
  }
}
